import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface PortalProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const Portal: React.FunctionComponent<PortalProps> = ({ children, style }) => {
  const [el] = useState(document.createElement('div'));

  useEffect(() => {
    el.setAttribute('style', '');
    el.style.width = baseStyle.width;
    el.style.position = baseStyle.position;

    document.body.appendChild(el);
    return () => {
      document.body.removeChild(el);
    };
  }, [el]);

  useEffect(() => {
    el.setAttribute('style', '');
    el.style.width = baseStyle.width;
    el.style.position = baseStyle.position;

    if (style) {
      for (const key in style) {
        if (Object.prototype.hasOwnProperty.call(style, key)) {
          // @ts-ignore
          el.style[key] = style[key];
        }
      }
    }
  }, [el, style]);

  return createPortal(children, el);
};

const baseStyle = {
  width: '100%',
  position: 'absolute',
} as const;

export default Portal;
